import React, { createContext, useMemo } from 'react';

import { useMachine } from '@xstate/react';
import type { ActorRefFrom } from 'xstate';

import { rootStateMachine } from '@/router/state/root/root-state-machine';

export interface AuthContextValue {
  actorRef: ActorRefFrom<typeof rootStateMachine>;
  state: ReturnType<typeof useMachine<typeof rootStateMachine>>[0];
  send: ReturnType<typeof useMachine<typeof rootStateMachine>>[1];
}

export const RootContext = createContext<AuthContextValue | undefined>(undefined);

export const RootContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isFirstMount = React.useRef(true);
  const isColdStart = isFirstMount.current;
  React.useEffect(() => {
    isFirstMount.current = false;
  }, []);
  return <RootContextManager isColdStart={isColdStart}>{children}</RootContextManager>;
};

const RootContextManager: React.FC<{
  children: React.ReactNode;
  isColdStart: boolean;
}> = ({ children, isColdStart }) => {
  const [state, send, actorRef] = useMachine(rootStateMachine, {
    input: {
      isColdStart,
    },
  });
  const value = useMemo(() => ({ actorRef, state, send }), [actorRef, state, send]);
  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
};
